export class PlayControls {
  constructor() {
    this.input = "";
    this.outcome = "";
  }
  public input: string;
  public outcome: string;
}
